import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../services/api";

export default function AdRedirectPage() {
  const { shortCode } = useParams();
  const [data, setData] = useState(null);
  const [timer, setTimer] = useState(5); // default 5 seconds

  // Fetch link & ad data
  useEffect(() => {
    async function load() {
      try {
        const res = await api.get(`/s/${shortCode}/ad`);
        const responseData = res?.data || {};
        setData(responseData);
        setTimer(responseData.countdown ?? 5);
      } catch (err) {
        console.error("Error loading ad:", err);
      }
    }
    load();
  }, [shortCode]);

  // Countdown timer
  useEffect(() => {
    if (!data) return;

    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer(t => t - 1);
    }, 10000);

    return () => clearInterval(interval);
  }, [data, timer]); // only restart interval when data changes

  // Redirect when timer reaches 0
  useEffect(() => {
    if (timer === 0 && data?.redirectUrl) {
      window.location.href = data.redirectUrl;
    }
  }, [timer, data]);


  if (!data) return <p>Loading ad...</p>;

  return (
    <div className="ad-container" style={{ textAlign: "center", padding: "50px" }}>
      <h2>Your link is almost ready...</h2>

      {data.adType === "image" && data.adContent?.image && (
        <a href={data.adContent.clickUrl} target="_blank" rel="noreferrer">
          <img
            src={data.adContent.image}
            alt="Advertisement"
            style={{ width: "100%", maxWidth: 600 }}
          />
        </a>
      )}

      <p>Redirecting in {timer} second{timer !== 1 ? "s" : ""}...</p>
    </div>
  );
}